import React from 'react';
import PageLayout from '@components/layout/PageLayout';
import EvidenceManagementDashboard from '@components/features/evidence/EvidenceManagementDashboard';

const EvidenceManagementPage: React.FC = () => {
  return (
    <PageLayout>
      <EvidenceManagementDashboard />
    </PageLayout>
  );
};

export default EvidenceManagementPage;
